import { useNavigate } from "@tanstack/react-router";
import { useMemo } from "react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { toast } from "@/components/kit";
import { ProductFormPageHeader } from "@/modules/products/presentation/ui/ProductFormPageHeader";
import { useCreateImportOrder, useImportOrderExchangeSettings } from "../../api/import-orders-queries";
import {
  consumeImportOrderPhase13DraftForReturnTo,
  consumeImportOrderPhase13Prefill,
} from "../../lib/import-prefill-phase13";
import { ImportOrderPhase13Form } from "../../ui/ImportOrderPhase13Form";

export function ImportOrderNewPage() {
  const nav = useNavigate();
  const createImport = useCreateImportOrder();
  const exchangeSettings = useImportOrderExchangeSettings();
  const prefillDefaults = useMemo(() => {
    const returnTo = "/app/import-orders/new";
    const draftValues = consumeImportOrderPhase13DraftForReturnTo(returnTo);
    if (draftValues) return draftValues;

    const prefillLines = consumeImportOrderPhase13Prefill();
    if (prefillLines?.length) {
      return { lines: prefillLines, markOrdered: false };
    }
    return undefined;
  }, []);

  const defaultExchangeRate =
    exchangeSettings.data?.lastExchangeRate ??
    exchangeSettings.data?.defaultExchangeRate;

  return (
    <>
      <Header />
      <Main>
        <ProductFormPageHeader
          title="ສັ່ງນຳເຂົ້າໃໝ່"
          subtitle="ບັນທຶກ order ຈາກແອບຈີນ + ຄຳນວນ landed cost"
          onBack={() => nav({ to: "/app/import-orders" })}
        />
        <ImportOrderPhase13Form
          defaultExchangeRate={defaultExchangeRate}
          defaultValues={prefillDefaults}
          productCreateReturnTo="/app/import-orders/new"
          submitting={createImport.isPending}
          submitLabel={
            createImport.isPending ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກໃບສັ່ງ"
          }
          onSubmit={async (input) => {
            try {
              const order = await createImport.mutateAsync(input);
              toast.success("ບັນທຶກໃບສັ່ງສຳເລັດ");
              nav({
                to: "/app/import-orders/$id",
                params: { id: order.id },
              });
            } catch (e) {
              toast.error("ບັນທຶກລົ້ມເຫຼວ", {
                description: e instanceof Error ? e.message : undefined,
              });
            }
          }}
        />
      </Main>
    </>
  );
}
